import styled from "styled-components";
import { motion } from "framer-motion";

// main header
export const Container = styled.div`
  padding: 2.1rem 3.2rem;
  .inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      .icon-box {
        width: 3.5rem;
        height: 3.4rem;
        img {
          max-width: 100%;
        }
      }
      .img-box {
        width: 17.6rem;
        display: flex;
        img {
          max-width: 100%;
        }
      }
      .company-name {
        margin-left: 3.5rem;
        font-size: 2.2rem;
        font-weight: 400;
      }
    }
    .sub {
      display: flex;
      gap: 1.6rem;
      span {
        font-size: 1.6rem;
        letter-spacing: -0.05rem;
        &.hr {
          height: 1.2rem;
          width: 1px;
          background-color: #9a9a9a;
          transform: translateY(3px);
        }
        strong {
          display: inline-block;
        }
      }
    }
  }
  &.bb_1 {
    border-bottom: 1px solid #ebebeb;
  }
  @media screen and (max-width: 768px) {
    padding: 2rem;
    position: relative;
    .inner {
      .img-box {
        max-width: 14rem;
      }
    }
    &.bb_1 {
      height: 13rem;
      .inner {
        flex-direction: column;
        gap: 1rem;
        .logo {
          width: 100%;
          .company-name {
            font-size: 1.6rem;
          }
        }
        .sub {
          background-color: #ebebeb;
          position: absolute;
          bottom: 0rem;
          padding: 1rem 2rem;
          border-radius: 8px 8px 0 0;
          gap: 0.6rem;
          width: 94%;
          justify-content: space-between;
          span {
            font-size: 1.4rem;
            strong {
              display: none;
            }
          }
        }
      }
    }
  }
`;

export const LayoutContainer = styled.div``;

export const ContainerWrapper = styled.div`
  position: relative;
  overflow: hidden; // 페이지 이동 시 요소가 영역을 벗어나지 않도록
  display: grid;
  grid-template-columns: 24rem auto;
  @media screen and (max-width: 768px) {
    display: block;
  }
`;

export const LayoutWrapper = styled(motion.main)`
  min-height: calc(100vh);
  height: calc(100vh);
  /* background-color: #f9fbfc; */
  /* padding: 2.8rem 4rem; */
  @media screen and (max-width: 768px) {
    min-height: auto;
    height: 100%;
    padding: 2rem;
  }
`;

export const NavContainer = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 1.8rem 0;
  height: 100%;
  position: relative;
  background-color: #323232;
  .logo {
    padding: 1rem 2.4rem;
    display: flex;
    gap: 0.5rem;
    span {
      img {
        width: 100%;
      }
    }
  }
  ul {
    li {
      padding: 1px;
      position: relative;
      height: 5rem;
      /* padding-left: 30px; */
      cursor: pointer;
      .item-box {
        display: flex;
        align-items: center;
        gap: 1rem;
        max-width: 19.2rem;
        height: 100%;
        padding: 1.3rem 3rem;
        span {
          font-size: 1.4rem;
          font-weight: 300;
          color: white;
          line-height: 22.5px;
        }
        .icon-box {
          width: 22.5px;
          height: 22.5px;
          img {
            width: 100%;
          }
        }
      }
      &.active {
        .item-box {
          span {
            color: white;
            font-weight: 500;
          }
        }
      }
      /* &.active::after {
        content: "";
        position: absolute;
        background-color: #30a690;
        height: 4.8rem;
        width: 2.6rem;
        top: 1px;
        left: -1.4rem;
        border-radius: 0.4rem;
      } */
    }
  }
  .nav-footer {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    margin-top: auto;
    padding: 1.6rem 2.4rem 0 3.2rem;
    font-size: 1.4rem;
    button {
      padding: 0;
      border: 0;
      background: none;
      color: inherit;
      font: inherit;
      cursor: pointer;
    }
    .company-name {
      font-size: 1.8rem;
      font-weight: 500;
      color: white;
    }
    .user-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.8rem;
      overflow-wrap: anywhere;
      color: white;
    }
    .logout-button {
      color: #6b7c78;
      display: flex;
      align-items: center;
      gap: 10px;
      font-weight: 600;
      span {
        display: flex;
        img {
          width: 1.8rem;
          height: 1.8rem;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .nav-footer {
      padding: 1rem;
    }
    ul {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      li {
        padding-left: 0;
        .item-box {
          max-width: none;
          justify-content: center;
          gap: 0.4rem;
        }
        &.active::after {
          content: none;
        }
      }
    }
  }
`;

export const StorageVolumnBox = styled.div`
  width: 100%;
  .inner {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    justify-content: center;
    align-items: stretch;
    max-width: 19.2rem;
    padding: 1.4rem 1.6rem;
    border: 1px solid #e3e7f2;
    border-radius: 0.8rem;
    background-color: #f7f8fb;
    .storage-title {
      color: #6b7c78;
      font-size: 1.3rem;
      font-weight: 500;
    }
    .storage-volume {
      display: flex;
      align-items: center;
      gap: 0.4rem;
      color: #0e1c32;
      font-size: 1.4rem;
      font-weight: 700;
      white-space: nowrap;
      .divider {
        color: #9aaba7;
        font-weight: 500;
      }
    }
    .storage-progress {
      overflow: hidden;
      width: 100%;
      height: 0.8rem;
      border-radius: 999px;
      background-color: #dceaef;
      .storage-progress-bar {
        height: 100%;
        border-radius: inherit;
        background-color: #249fbf;
        transition: width 0.2s ease;
      }
    }
    .storage-percent {
      color: #6b7c78;
      font-size: 1.2rem;
      font-weight: 500;
      text-align: right;
    }
  }
  @media screen and (max-width: 768px) {
    .inner {
      max-width: none;
      padding: 1.2rem;
    }
  }
`;
